package com.mshopsas.enterprise.aiw.scan.screens.search

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.mshopsas.enterprise.aiw.scan.di.getScreenModel
import com.mshopsas.enterprise.aiw.scan.screens.commons.base.SIDE_EFFECTS_KEY
import com.mshopsas.enterprise.aiw.scan.screens.search.detail.SearchProductDetailScreen
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach

data object SearchProductScreen : Screen {

    @Composable
    override fun Content() {

        val screenModel: SearchProductScreenModel = getScreenModel()
        val navigator = LocalNavigator.currentOrThrow

        LaunchedEffect(SIDE_EFFECTS_KEY) {
            screenModel.effect.onEach {
                when (it) {
                    SearchProductContract.Effect.Navigation.ToBack -> {
                        navigator.pop()
                    }
                    is SearchProductContract.Effect.Navigation.ToProductDetail -> {
                        navigator.push(SearchProductDetailScreen(it.product))
                    }
                }
            }.collect()
        }

        val state by screenModel.viewState.collectAsState()
        val onEventSent: (SearchProductContract.Event) -> Unit = { event -> screenModel.setEvent(event) }

        SearchProductView(state, onEventSent)

    }
}
